import { ReactComponent as AddIcon } from "../../assets/icons/header/add.svg";
import { ReactComponent as ClockIcon } from "../../assets/icons/header/clock.svg";

const Search = () => {
	return (
		<>
			<div className="hk-border " style={{ height: "116px" }}>
				<div className="d-flex justify-content-center align-items-center gap-2 p-2">
					<AddIcon width="28" height="28" />
					<ClockIcon width="28" height="28" />

				</div>
			</div>
		</>
	);
};

export default Search;
